import React, { Component } from "react";
import Radio from "semantic-ui-react/dist/es/addons/Radio";

import Flatpickr from "react-flatpickr";
import moment from "moment-timezone";

import { ReactComponent as Calendar } from "../../../../assets/svg/calendar.svg";
import "./Flatpickr.css";
import Icon from "semantic-ui-react/dist/es/elements/Icon";

class Duration extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDurationOthers: false,
        };
    }

    componentDidMount() {}

    updateFilter = (duration) => {
        let durationConfig = {
            duration,
        };
        if (duration === "custom") {
            durationConfig.startDateTime = moment().tz(this.props.user_timezone_name).startOf("day").format("YYYY-MM-DDTHH:mm:ss");
            durationConfig.endDateTime = moment().tz(this.props.user_timezone_name).format("YYYY-MM-DDT00:00:00");
            durationConfig.rollingDate = false;
        } else {
            durationConfig.startDateTime = null;
            durationConfig.endDateTime = null;
            durationConfig.rollingDate = false;
        }
        this.props.updateFilters({ ...this.props.filters, ...durationConfig });
    };

    updateRollingDate = (rollingDate) => {
        this.props.updateFilters({ ...this.props.filters, rollingDate });
    };

    updateStartDate = (date) => {
        this.props.updateFilters({ ...this.props.filters, startDateTime: date[0] });
    };

    updateEndDate = (date) => {
        this.props.updateFilters({ ...this.props.filters, endDateTime: date[0], rollingDate: false });
    };

    getStartMaxDate = () => {
        return this.props.filters.rollingDate ? new Date() : this.props.filters.endDateTime;
    };

    filterDisplay = () => {
        const durationSelected = this.props.filters.duration;
        const startDateTime = this.props.filters.startDateTime || new Date();
        const endDateTime = this.props.filters.endDateTime || new Date();
        const rollingDate = this.props.filters.rollingDate;
        let showDurationOthers = this.state.showDurationOthers || ["lastmonth", "lastquarter", "last2quarter"].includes(durationSelected);

        return (
            <div className="filter-list-items">
                <div className="filter-list-item">
                    <Radio checked={durationSelected === "24HRS"} onClick={() => this.updateFilter("24HRS")} label="24 Hrs" />
                </div>
                <div className="filter-list-item">
                    <Radio checked={durationSelected === "1"} onClick={() => this.updateFilter("1")} label="Today" />
                </div>
                <div className="filter-list-item">
                    <Radio checked={durationSelected === "7"} onClick={() => this.updateFilter("7")} label="7 Days" />
                </div>
                <div className="filter-list-item">
                    <Radio checked={durationSelected === "30"} onClick={() => this.updateFilter("30")} label="30 Days" />
                </div>
                <div className="filter-list-item">
                    <Radio checked={durationSelected === "custom"} onClick={() => this.updateFilter("custom")} label="Custom Duration" />
                </div>
                {durationSelected === "custom" && (
                    <>
                        <div className="filter-list-item custom-duration selector">
                            <div className="custom-duration-date-label">
                                <span>From:</span>
                            </div>
                            <Flatpickr
                                data-input
                                className="skiptranslate"
                                options={{
                                    altInput: true,
                                    enableTime: true,
                                    enableSeconds: true,
                                    static: false,
                                    minuteIncrement: 30,
                                    defaultDate: moment().tz(this.props.user_timezone_name).format("YYYY-MM-DDTHH:mm:ss"),
                                    maxDate: this.getStartMaxDate(),
                                }}
                                onClose={(selectedDates) => this.updateStartDate(selectedDates)}
                                onReady={(_, __, fp) => {
                                    fp.calendarContainer.classList.add("skiptranslate");
                                    fp.calendarContainer.classList.add("filter-custom-duration");
                                }}
                                value={startDateTime}
                                render={({ defaultValue, value, ...props }, ref) => {
                                    return <CustomCalendarInput defaultValue={defaultValue} inputRef={ref} {...props} />;
                                }}
                            />
                        </div>
                        <div className="filter-list-item custom-duration selector">
                            <div className="custom-duration-date-label">
                                <span>To:</span>
                                <Radio checked={!rollingDate} onClick={() => this.updateRollingDate(false)} />
                            </div>
                            <Flatpickr
                                data-input
                                className="skiptranslate"
                                options={{
                                    altInput: true,
                                    enableTime: true,
                                    enableSeconds: true,
                                    static: false,
                                    minuteIncrement: 30,
                                    defaultDate: moment().tz(this.props.user_timezone_name).format("YYYY-MM-DDTHH:mm:ss"),
                                    maxDate: moment().tz(this.props.user_timezone_name).format("YYYY-MM-DDTHH:mm:ss"),
                                    minDate: startDateTime,
                                }}
                                onClose={(selectedDates) => this.updateEndDate(selectedDates)}
                                onReady={(_, __, fp) => {
                                    fp.calendarContainer.classList.add("skiptranslate");
                                    fp.calendarContainer.classList.add("filter-custom-duration");
                                }}
                                value={endDateTime}
                                render={({ defaultValue, value, ...props }, ref) => {
                                    return <CustomCalendarInput defaultValue={defaultValue} inputRef={ref} {...props} />;
                                }}
                            />
                        </div>
                        <div className="filter-list-item custom-duration selector">
                            <div className={`custom-duration-date-label ${this.props.isChartFilter ? "chartFilterNow" : "now"}`}>
                                <Radio checked={rollingDate} onClick={() => this.updateRollingDate(true)} label="Now" />
                            </div>
                        </div>
                    </>
                )}
                <div className="filter-list-item-duration-others" onClick={() => this.setState({ showDurationOthers: !this.state.showDurationOthers })}>
                    Others <Icon name="dropdown" />
                </div>
                {showDurationOthers && (
                    <div className="duration-others">
                        <div className="filter-list-item">
                            <Radio checked={durationSelected === "lastmonth"} onClick={() => this.updateFilter("lastmonth")} label="Last Month" />
                        </div>
                        <div className="filter-list-item">
                            <Radio checked={durationSelected === "lastquarter"} onClick={() => this.updateFilter("lastquarter")} label="Last Quarter" />
                        </div>
                        <div className="filter-list-item">
                            <Radio checked={durationSelected === "last2quarter"} onClick={() => this.updateFilter("last2quarter")} label="Last 2 Quarters" />
                        </div>
                    </div>
                )}
            </div>
        );
    };

    render() {
        return (
            <div className="filter-type filter-type-duration">
                <div className="filter-type-header">
                    <div className="filter-type-header-left">
                        <span className={`filter-type-name`}>{this.props.showChartComparision ? "Compare With" : "Duration"}</span>
                    </div>
                </div>
                {this.filterDisplay()}
            </div>
        );
    }
}

const CustomCalendarInput = ({ value, defaultValue, inputRef, ...props }) => {
    return (
        <div className="calender-input">
            <input {...props} defaultValue={defaultValue} ref={inputRef} />
            <span>
                <Calendar data-toggle />
            </span>
        </div>
    );
};

export default Duration;
